import type { UserDto } from '@bqcrm/shared';

/** Treść PUT /users/:id — dane konta i pracownika bez zmian, poza wskazanymi. */
export const userBody = (u: UserDto, patch: Record<string, unknown> = {}) => ({
  email: u.email ?? '',
  fullName: u.fullName,
  phone: u.phone,
  isSubcontractor: u.isSubcontractor,
  roleCodes: u.roleCodes,
  allCompanies: u.allCompanies,
  companyIds: u.companyIds,
  active: u.active,
  ...patch,
});
